module.exports = "/_next/static/images/john-c8d2d905e98128a5ff563b2a0562f96d.jpeg";